import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { MailX, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [email, setEmail] = useState('');
  const [state, setState] = useState('loading');

  useEffect(() => {
    if (!token) { setState('invalid'); return; }
    axios.get(`${API}/public/unsubscribe/info`, { params: { token } })
      .then((r) => { setEmail(r.data.email); setState('confirm'); })
      .catch(() => setState('invalid'));
  }, [token]);

  const unsubscribe = async () => {
    setState('working');
    try {
      await axios.post(`${API}/public/unsubscribe`, { token });
      setState('done');
    } catch { setState('invalid'); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="bg-white border border-slate-200 rounded-2xl p-8 max-w-md w-full text-center shadow-sm" data-testid="unsubscribe-card">
        <div className="w-12 h-12 rounded-full bg-[#0E1944] text-white font-bold flex items-center justify-center mx-auto mb-4">A</div>
        {state === 'loading' && <p className="text-sm text-slate-500">Loading…</p>}
        {state === 'invalid' && <p className="text-sm text-red-600" data-testid="unsubscribe-invalid">This unsubscribe link is invalid or has expired.</p>}
        {state === 'confirm' && (
          <>
            <MailX className="w-8 h-8 text-slate-400 mx-auto mb-3" />
            <h1 className="text-lg font-bold text-slate-900 mb-2">Unsubscribe from AAWTA emails?</h1>
            <p className="text-sm text-slate-500 mb-6"><strong>{email}</strong> will no longer receive newsletters and campaign emails from AAWTA. Operational emails (account, meetings) are not affected.</p>
            <Button className="bg-[#C2185B] hover:bg-[#a3154c] w-full" onClick={unsubscribe} data-testid="unsubscribe-confirm-btn">Unsubscribe</Button>
          </>
        )}
        {state === 'working' && <p className="text-sm text-slate-500">Processing…</p>}
        {state === 'done' && (
          <>
            <CheckCircle2 className="w-8 h-8 text-emerald-500 mx-auto mb-3" />
            <h1 className="text-lg font-bold text-slate-900 mb-2">You've been unsubscribed</h1>
            <p className="text-sm text-slate-500" data-testid="unsubscribe-done">{email} has been removed from AAWTA campaign emails.</p>
          </>
        )}
      </div>
    </div>
  );
}
